/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PlatformKillswitchDefinition,
  PlatformKillswitchDefinition$inboundSchema,
} from "./platformkillswitchdefinition.js";

export type ListDefinitionsResponseBody = {
  definitions: Array<PlatformKillswitchDefinition>;
};

/** @internal */
export const ListDefinitionsResponseBody$inboundSchema: z.ZodMiniType<
  ListDefinitionsResponseBody,
  unknown
> = z.object({
  definitions: z.array(PlatformKillswitchDefinition$inboundSchema),
});

export function listDefinitionsResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListDefinitionsResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDefinitionsResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDefinitionsResponseBody' from JSON`,
  );
}
